"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertTraceCornerRadius = convertTraceCornerRadius;
const reviews_1 = require("../../reviews");
const common_1 = require("./common");
function convertTraceCornerRadius(nodes) {
    return (problem) => {
        const designatorUidMap = {};
        const affectedItem = problem.affectedItems.at(0);
        if (!affectedItem) {
            return { name: null, designator: null, net: null, designatorUidMap };
        }
        const netUid = (0, common_1.getNetUidForNode)(affectedItem.uid, nodes);
        const net = (0, common_1.sanitizeDesignator)((0, common_1.getNetNameForNode)(affectedItem.uid, nodes));
        const node = nodes[affectedItem.uid];
        const designator = (0, common_1.sanitizeDesignator)((0, common_1.getLabelForPcbNode)(node));
        designatorUidMap[designator] = affectedItem.uid;
        if (net && netUid) {
            designatorUidMap[net] = netUid;
        }
        return {
            designator: designator ?? null,
            name: designator ?? null,
            net: net ?? null,
            status: reviews_1.ReviewStatus.WARNING,
            designatorUidMap,
        };
    };
}
//# sourceMappingURL=traceCornerRadius.js.map